import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { apiRequest } from '../authConfig.js';
import { getMyReports } from '../api.js';
import styles from './Home.module.css';

export default function Home() {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchReports() {
      try {
        let tokenResponse;
        try {
          tokenResponse = await instance.acquireTokenSilent({
            ...apiRequest,
            account: accounts[0],
          });
        } catch (silentErr) {
          if (silentErr instanceof InteractionRequiredAuthError) {
            tokenResponse = await instance.acquireTokenPopup({
              ...apiRequest,
              account: accounts[0],
            });
          } else {
            throw Object.assign(silentErr, { _phase: 'acquireTokenSilent' });
          }
        }

        // Use idToken: MS Graph access tokens cannot be validated by 3rd parties.
        // The ID token has aud=clientId and is signed by our tenant — verifiable.
        const idToken = tokenResponse.idToken;
        if (!idToken) throw new Error('ID token unavailable');
        const data = await getMyReports(idToken);
        setReports(data);
      } catch (err) {
        console.error('Failed to fetch reports:', err);
        setError(`Erro ao carregar relatórios: ${err.message || err}`);
      } finally {
        setLoading(false);
      }
    }

    fetchReports();
  }, [instance, accounts]);

  if (loading) {
    return (
      <main className={styles.main}>
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <p>A carregar relatórios...</p>
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main className={styles.main}>
        <div className={styles.errorBox}>
          <p>{error}</p>
        </div>
      </main>
    );
  }

  return (
    <main className={styles.main}>
      <h1 className={styles.title}>Os meus relatórios</h1>

      {reports.length === 0 ? (
        <div className={styles.empty}>
          <p>Não tem relatórios atribuídos.</p>
          <p>Contacte o administrador para obter acesso.</p>
        </div>
      ) : (
        <div className={styles.grid}>
          {reports.map((report) => (
            <button
              key={report.reportId}
              className={styles.card}
              onClick={() =>
                navigate(`/report/${report.reportId}`, {
                  state: { workspaceId: report.workspaceId, reportName: report.reportName },
                })
              }
            >
              <div className={styles.cardIcon}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <path d="M9 9h6M9 13h6M9 17h4" />
                </svg>
              </div>
              <div className={styles.cardBody}>
                <h2 className={styles.cardTitle}>{report.reportName}</h2>
                <p className={styles.cardSub}>Clique para visualizar</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </main>
  );
}
